import React from "react";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { Link } from "react-router-dom";
import "../../../scss/global.scss";

export const GEDHdrConfirmPage = () => {
  return (
    <AppWrapper id="ged-confirmation" pageTitle="My Assays">
      <div className="container main-content">
        <div className="row">
          <div className="col">
            <h1>HDR Reference Assay</h1>
          </div>
        </div>

        <div id="hdr-confirmation-page" className="container row">
          <div className="row line-1">
            <p>
              HDR Genome Edit Detection Assays must be run duplexed with an HDR
              Reference Assay.
            </p>
          </div>

          <div className="row line-2">
            <p>
              A recommendation for a predesigned, amplicon length-matched
              reference assay is available on the Assay Details page.
              Alternatively, you may design your own HDR Reference Assay. For
              optimal performance design an HDR Reference Assay with a 55 °C
              annealing temperature and amplicon length similar to the HDR
              Genome Edit Detection assay that it is being duplexed with.
            </p>
          </div>
        </div>

        <Link to={"/digital-assays/assay-design-history"}>
          <button class="outline rounded">Continue</button>
        </Link>
      </div>
    </AppWrapper>
  );
};
